import React, { useState } from "react";
import type { EditableHabit } from "../types";
import HabitTypeSelection from "./HabitTypeSelection";
import FreeformHabitForm from "./FreeformHabitForm";
import MultiDayHabitForm from "./MultiDayHabitForm";
import SingleSiteHabitForm from "./SingleSiteHabitForm";
import { useNavigate } from "react-router-dom";

export type StateProps = {};
export type DispatchProps = {
  createHabit: (arg0: EditableHabit, arg1: boolean, arg2: () => void) => void;
};
export type OwnProps = {};
export type Props = StateProps & DispatchProps & OwnProps;
export default function CreateHabit(props: Props) {
  const nav = useNavigate();

  const callback = () => {
    nav("/manage");
  };

  const onSave = (habit, install) => {
    props.createHabit(habit, install, callback);
  };

  const [selection, setSelection] = useState("none");

  switch (selection) {
    case "freeform":
      return <FreeformHabitForm onSave={onSave} {...props} />;

    case "multi-day":
      return <MultiDayHabitForm onSave={onSave} {...props} />;

    case "single-site":
      return <SingleSiteHabitForm onSave={onSave} {...props} />;

    default:
      return <HabitTypeSelection onTypeSelection={setSelection} />;
  }
}
